(function () {
	'use strict';

	angular
		.module('in-out-rm')
		.directive('nbCard', nbCard)
		.controller('NbCardController', NbCardController);

	nbCard.$inject = ['$compile', '$http', '$templateCache', '$parse', 's3', 'bootModal','$filter','searchService','pinContent'];

	function nbCard($compile, $http, $templateCache, $parse, s3, bootModal, $filter,searchService,pinContent) {
		var directive = {
			restrict: 'A',
			scope: true,
			link: linkFunc,
			controller: 'NbCardController',
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			// this is the place to show and hide elements of similar cards similar to config
			if (scope.x.activity == 4 || (scope.x.activity_enhancer_id !== null &&
					scope.x["t" + scope.x.activity + "_unique_user_id"] != scope.x.activity_enhancer_id)) {
				scope.isEnhancer = true;
			}
			if ((scope.x.activity == 1 || scope.x.activity == 4 || scope.x.activity == 2) && scope.x.activity_type == 2) {
				scope.actionString = $filter('asPortalLang')('Liked_Post',"liked a post");
			} else if ((scope.x.activity == 1 || scope.x.activity == 4 || scope.x.activity == 2) && scope.x.activity_type == 3) {
				scope.actionString = $filter('asPortalLang')('Comment_On_Post',"commented on a post");
			} else if ((scope.x.activity == 1 || scope.x.activity == 4) && scope.x.activity_type == 5) {
				scope.actionString = $filter('asPortalLang')('Answered_Poll',"answered a poll");
			} else if (scope.x.activity == 2 && scope.x.activity_type == 5) {
				scope.actionString = $filter('asPortalLang')('Answered_Poll',"answered a poll");
			} else if (scope.x.activity == 4) {
				scope.actionString = $filter('asPortalLang')('Posted_Lc',"posted");
			}

			var templateLoaded = false;
			scope.$watch(attrs.lol, function (value) {
				if(!templateLoaded) {
					loadTemplate();
				}
			});

			function loadTemplate() {
				var templateLoaded = true;
				var openIndex;
				var card;
				if (scope.x.activity == 1) {
					card = "nb_card_";
					scope.link = 'post/'+scope.x.activity_id;
					if(scope.x.activity_type == 4 || scope.x.activity_type == 5){
		                scope.featureName = 'poll';
						scope.shareTitle = $filter('asPortalLang')('Nbcard_Share_Poll',"Share Poll");
						scope.linkTitle = "New Poll";
	            	}
		            else{
		                scope.featureName = 'post';
						scope.shareTitle = $filter('asPortalLang')('Nbcard_Share_Post',"Share Post");
						scope.linkTitle = "New Post";
		            }
				} //news card.. to be changed to universal card
				else if (scope.x.activity == 2) {
					card = "universal_mm_card_";
				} //memory card
				else if (scope.x.activity == 4) {
					card = "universal_ep_card_";
					scope.link = 'events/'+scope.x.t4_events_id;
	                scope.featureName = 'event';
					scope.shareTitle = $filter('asPortalLang')('Sevt_Share_Event',"Share Event");
					scope.linkTitle = scope.x.t4_eventName;
				} //eventpost card
				else if (scope.x.activity == 5) {
						card = "nb_job_";
					scope.link = 'jobs/view/'+scope.x.activity_id;
					if(scope.x.t5_job_type == "1"){
						scope.shareTitle = $filter('asPortalLang')('Nbcard_Share_Internship',"Share Internship");
						scope.featureName = 'internship';
					}
					else if(scope.x.t5_job_type == "0"){
						scope.shareTitle = $filter('asPortalLang')('Nbcard_Share_Job',"Share Job");
						scope.featureName = 'job';
					}
					scope.linkTitle = scope.x.t5_designation_name;
				} //for new job endorsed
				else if (scope.x.activity == 10) {
					card = "nb_wu_";
				} //for work update
				else if (scope.x.activity == 9) {
					card = "nb_cu_";
				} //for city update
				else if (scope.x.activity == 6) {
					card = "jsf_card_";
				} //for city update
				else if (scope.x.activity == 13) {
					card = "campus_feed_card_";
					scope.link = 'f/'+scope.x.t13_campusfeedid;
					scope.shareTitle = $filter('asPortalLang')('Nbcard_Share_Campusfeed',"Share [TERM:Campusfeed]");
					scope.featureName = 'campusfeed';
					scope.linkTitle = scope.x.t13_heading;
				} //for campus feed
				
				if (scope.x.activity_type == 4 || scope.x.activity_type == 5) {
					openIndex = 2;
				} //for poll card in news, memory, eventpost
				else {
					openIndex = 1;
				}
				if (scope.x.activity == 2 && scope.x.activity_type == 8) {
					openIndex = 1;
				} //simple memory crd
				
				if (scope.x.activity == 3) {
					card = "event_card";
					openIndex = '';
					scope.link = 'events/'+scope.x.activity_id;
					scope.shareTitle = $filter('asPortalLang')('Sevt_Share_Event',"Share Event");
					scope.featureName = 'event';
					scope.linkTitle = scope.x.t3_title;
				} //for event card
				else if(scope.x.activity == 14) {
					card = 'donation_card';
					openIndex = '';
					scope.link = 'donation/'+scope.x.t14_project_id;
					scope.shareTitle = $filter('asPortalLang')('Nbcard_Share_Donation',"Share Donation");
					scope.featureName = 'donation';
					scope.linkTitle = scope.x.t14_name;
				}
				else if(scope.x.activity == 15) {
					card='gallery_card';
					openIndex = '';
					scope.link = 'galleries/'+scope.x.t15_id;
					scope.shareTitle = $filter('asPortalLang')('Sgall_Share_gallery',"Share Gallery");
					scope.featureName = 'gallery';
					scope.linkTitle = scope.x.t15_name;
				}
				
				if (scope.x.activity != 7 && scope.x.activity != 8) { //removed case of new tag creation
					// if(scope.x.activity==2){
					$http.get("./templates/modals/material/" + card + openIndex + ".html",{cache: $templateCache})
						.success(getCardTemplateSuccess).error(getCardTemplateError);
				}

				function getCardTemplateSuccess(templateContent) {
					try {
						element.append($compile(templateContent)(scope));
						as_upgrade(10);
					} catch (err) {
						// console.log(err);
					}
				}

				function getCardTemplateError(error) {

				}

			}

		}
	}

	NbCardController.$inject = ['$scope', '$http', '$sce', 's3','bootModal','$rootScope','adminMailClone','mailTemplate','$timeout','asSocialPlatforms','adminRights','features','$state','asimageModal','addEditVideo','cache','imageBulkResizer','adminNotificationClone','socialShare','Upload','$filter','$injector','searchService','jobsConfiguration','pinContent'];

	function NbCardController($scope, $http, $sce, s3, bootModal,$rootScope,adminMailClone,mailTemplate,$timeout,asSocialPlatforms,adminRights,features,$state,asimageModal,addEditVideo,cache,imageBulkResizer,adminNotificationClone,socialShare,Upload,$filter,$injector,searchService,jobsConfiguration,pinContent) {
		//Variables
		$scope.s3_url = s3.s3base_url;
		$scope.page_root = $rootScope.COMM_APPBASE;
		var str = $scope.x["t" + $scope.x.activity + "_content"];
		if(str && platform){
			var replace = new RegExp(window.APP_BASE_URL,"g");
			str = str.replace(replace, "/");
		}
		$scope.mainContent = $sce.trustAsHtml(str);
		var asEventService = $injector.get("asEventService");
        $scope.asEventService = asEventService;

		$scope.categoriesId=[];
		$scope.streamForGalleryImages = null;

		var intentRegex = 'share-btns',
			windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes',
			width = 550,
			height = 420,
			winHeight = screen.height,
			winWidth = screen.width;

		var likeCommentConfig = {
			1: 2,
			2: 3,
			3: 4,
			4: 5,
			5: 6,
			6: 9,
			7: 7,
			8: 1,
			9: 1,
			10: 1,
			11: 8,
			12: 1,
			13: 10,
			14: 11,
			15: 12
		};
		var comShown = -1;
		var activity_pin_str = pinContent.returnActivityStr();
		//@dinesh patil For edit feture
		$scope.editPost=false;
		$scope.editPostImages=[];
		$scope.oldPollOption;
		$scope.Updatedcontent="";
		$scope.numOptionsArray = [{
		    content: ""
		}];
		$scope.polldetails={
		    pollId      : "",
		    pollTitle   : "",
		    eventId     : "",
		    type        : "event"
		}
		$scope.postdetails={
		    postId      : "",
		    postTitle   : "",
		    eventId     : "",
		    type        : "event"
		}
		$scope.count=0;
		$scope.btnClicked=false;
		$scope.optionNumber=0;
		$scope.chipsSelected=[];
		$scope.showBlockReportMenu = false;
		$scope.imagesUploaded=imagesUploaded;
		$scope.uploadImages = uploadImages;
		$scope.uploadFiles = uploadFiles;
		$scope.imgName = {
		    myName: 1
		};
		$scope.increaseOptions = increaseOptions;;
        $scope.getPollTitle=getPollTitle;
        $scope.fillDesc=fillDesc;



		//Function Bindings
		$scope.displayVotes = displayVotes;
		$scope.getEventTitle = getEventTitle;
		$scope.getStartDate = getStartDate;
		$scope.getEventTime = getEventTime;
		$scope.getEventId = getEventId;
		$scope.getPostedDate = getPostedDate;
		$scope.getPosterName = getPosterName;
		$scope.getLikesCount = getLikesCount;
		$scope.pollOptions = pollOptions;
		$scope.eventImage = eventImage;
		$scope.getImages = getImages;
		$scope.getFiles = getFiles;
		$scope.posterBasicId = posterBasicId;
		$scope.posterBasic = posterBasic;
		$scope.eventCreatorUui = eventCreatorUui;
		$scope.eventEnhancer = eventEnhancer;
		$scope.eventEnhancerUid = eventEnhancerUid;
		$scope.getDesignation = getDesignation;
		$scope.votePercentage = votePercentage;
		$scope.getParentId = getParentId;
		$scope.getLikeStatus = getLikeStatus;
		$scope.likeCallBack = likeCallBack;
		$scope.likeText = likeText;
		$scope.tipShow = ($scope.$index==0 && $rootScope.newAdminPost);
		$scope.checkifcampusfeed_id = checkifcampusfeed_id;
		$scope.tippyOption = {arrow: true,theme: $scope.tipShow?'excited':'dark',zIndex:999,dynamicTitle:true,duration:[300,1000]};
        $scope.categories = features.getFeature('campusfeed.categories');
        $scope.redirectToGallery = redirectToGallery;
        $scope.openImages = openImages;
        $scope.getMorePhotos = getMorePhotos;
        $scope.isContentApproved = isContentApproved;
        $scope.addVideo=addVideo;
        $scope.votePreCallBack = votePreCallBack;



		$scope.getmainComments = getmainComments;
		$scope.getcommentText = getcommentText;
		$scope.checkDates1 = checkDates1;
		$scope.commentButtonClick = commentButtonClick;
		$scope.addNewComment = addNewComment;
		//this function is still common in many places to be replaced by appriappriate coomon function
		$scope.optionStyle = optionStyle;
		// function below is a common function to be put in a file later
		$scope.voteCallBack = voteCallBack;
		$scope.closeOptions = closeOptions;

		$scope.toggleCommentOptions = toggleCommentOptions;
		$scope.isViewingOptions = isViewingOptions;

		$scope.closeCommentOptions = closeCommentOptions;
		$scope.canDelete = canDelete;
		$scope.deleteNewsPost = deleteNewsPost;
		$scope.splicePost = splicePost;
		$scope.trimComment = trimComment;
		$scope.getLikeList = getLikeList;
		$scope.checkDates = checkDates;
		$scope.shareCard = shareCard;
		$scope.cloning = cloning;
		$scope.cloningFacebook = cloningFacebook;
		$scope.adminRights = adminRights.isAllowed;
		$scope.increaseOptions = increaseOptions;;
        $scope.getPollTitle=getPollTitle;
        $scope.fillDesc=fillDesc;
        $scope.imageRemove = imageRemove;
        $scope.removeFile = removeFile;
		$scope.getEditStatus=getEditStatus;
		$scope.canEdit = canEdit;
		$scope.savePostEdit = savePostEdit;
		$scope.savePollEdit = savePollEdit;
		$scope.loadAllComments = loadAllComments;
		$scope.cloningNotification = cloningNotification;
		$scope.shareModal = shareModal;
		$scope.getgridClasses = getgridClasses;
		$scope.getimageDivClasses = getimageDivClasses;
		$scope.getimageClasses = getimageClasses;
		$scope.getVideoUrl = getVideoUrl;
		$scope.pinPost = pinPost;
		$scope.isPostPinned = isPostPinned;
		$scope.unpinPost = unpinPost;
		$scope.returnPinDate = returnPinDate;

		$scope.buildMailTemp=$filter('asPortalLang')('Sgall_Build_Mail_Template',"Building your mail template");
		$scope.shareTargeted=$filter('asPortalLang')('Nbcard_Share_Audience',"Share this post with targeted audience");
        $scope.hideResult=$filter('asPortalLang')('Ucard_Hide_Results',"Hide Results");
		$scope.viewResult=$filter('asPortalLang')('Ucard_View_Results',"View Results");
		$scope.addPeople=$filter('asPortalLang')('Add_People',"Add People");
		$scope.application=$filter('asPortalLang')('Applications',"Applications");
		$scope.linkClicks=$filter('asPortalLang')('Link_Clicks',"Link Clicks");
		$scope.apply=$filter('asPortalLang')('Job_Apply',"Apply");
		$scope.applied=$filter('asPortalLang')('Job_Applied',"Applied");
		$scope.starts=$filter('asPortalLang')('Starts',"Starts");
		

		if(!isObject($scope.x.__options)) $scope.x.__options = {};

		//Activate Functions
		activate();

		function activate() {
			if (window.innerWidth <= 480) {
				$scope.limit_gallery = 4;
			} else {
				$scope.limit_gallery = 6;
			}
			if($scope.x.t15_images) {
				$scope.singleVideo = $scope.x.t15_no_photos == 1 && ($scope.x.t15_images[0].type == 1 || $scope.x.t15_images[0].item == 'video');
			}
			if(angular.isDefined($rootScope.app_data.email) 
		        && angular.isDefined($rootScope.appmeta)
		        && angular.isDefined($rootScope.appmeta.enable_report_functionality_in_app)
		        && $rootScope.appmeta.enable_report_functionality_in_app.indexOf($rootScope.app_data.email)>-1)
			{
			    $scope.showBlockReportMenu = true;
			}

			var currentDate = new Date();
			currentDate.setHours(0);
			currentDate.setMinutes(0);
			currentDate.setSeconds(0);
			currentDate.setMilliseconds(0);
			$scope.info = {};
			$scope.info.currentTime = Math.floor(currentDate.getTime() / 1000);

			var currentTime = Math.floor(Date.now() / 1000);
          	if ($scope.x.t1_time!==null && currentTime-$scope.x.t1_time < 120 ) {
            	$scope.tipShow = true;
            	$scope.tippyOption.theme = 'excited';
          	}

          	var uid = $scope.posterBasicId();
            var userType = 'user';
            if($rootScope.app_data.uid==uid)
                userType = 'poster';
            else if($rootScope.app_data.isAdmin)
                userType = 'admin';

            var state = null;
            var cas_id = null;
            var featureName = '';
            if($scope.x.activity == 1 || $scope.x.activity == 4){
            	if($scope.x.activity_type == 4 || $scope.x.activity_type == 5)
	                featureName = 'Poll';
	            else
	                featureName = 'Post';
            }
            else if($scope.x.activity == 3)
            	featureName = 'Event';
            else if($scope.x.activity == 5)
            	featureName = 'Job';
            else if($scope.x.activity == 13)
            	featureName = 'Campusfeed';
            else if($scope.x.activity == 14)
            	featureName = 'Donation';
            else if($scope.x.activity == 15)
            	featureName = 'Gallery';

            if(featureName){
            	var key = "t" + $scope.x.activity + "_state";
            	state = angular.isDefined($scope.x[key]) ? $scope.x[key] : null;
            	key = "t" + $scope.x.activity + "_cas_id";
            	cas_id = $scope.x[key] || null;
	            $scope.x.approvalStatusData = {
	                'userType':userType,
	                'featureName':featureName,
	                'approvalStatus':state,
	                'cas_obj':{'cas_id':cas_id},
	                'approverUui':"t" + $scope.x.activity + "_approver_uui"
	            };

	            if(featureName=='Poll' || featureName=='Post') $scope.canEdit();
            }

            if($scope.x.activity == 1 || $scope.x.activity == 4){
            	if($scope.x.activity_type == 4 || $scope.x.activity_type == 5){
		            var total_votes = 0;
					angular.forEach($scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id], function (value, key) {
						total_votes += parseInt(value.no_votes);
						if(value.voteID > 0) $scope.x.voted_by_me = true;
					});
					$scope.x.total_votes = total_votes;
            	}
            }	        
            if($scope.x.activity==5){
            	jobsConfiguration.get_template_data($scope.x,'noticeboard').then(function(formated_obj){
            		 angular.extend($scope.x, formated_obj);
            	});
            }
            if($scope.x.activity == 14){
            	
            	$scope.x.t14_donation_reqd_amt = parseInt($scope.x.t14_donation_reqd_amt);
            	$scope.x.t14_raised_amount = parseInt($scope.x.t14_raised_amount);
            	$scope.x.t14_no_donors = parseInt($scope.x.t14_no_donors);
            	$scope.x.t14_donation_target_donors = parseInt($scope.x.t14_donation_target_donors);

			    var p_b;
				var id = '#donation-'+$scope.x.t14_project_id;
				$timeout(function () {
					if(document.querySelector(id)!=null){
						var numerator = document.querySelector(id).getAttribute("currentstate");
			            var denominator = document.querySelector(id).getAttribute("finalstate");
			            var percent = numerator*100/denominator;
	            		if(0<percent) {
		            		document.querySelector(id).MaterialProgress.setProgress(Math.min(Math.max(1,percent),100));
	            		}
	            		if(percent >= 100){
	            			document.querySelector(id+" .progressbar").style.backgroundColor = "#66BB6A";
	            		}
        			}
				},3000);
			}
			if($scope.x.activity == 15){
				$scope.getMorePhotos();
			}

			if($scope.x.activity == 3 && $scope.x.t3_sdate) {
				var eventTime;
				if($scope.x.t3_stime){
				eventTime=timeparse($scope.x.t3_stime,$scope.x.t3_sdate);
				}
				else{
				eventTime=timeparse('00:00:00',$scope.x.t3_sdate);
				}
				var offset = timezoneToMinutes($scope.x.t3_timezone);
				var currentDate=new Date();
				$scope.x.t3_sLocalTime = timezoneCoverter(eventTime,offset,currentDate.getTimezoneOffset());
			}
			if($scope.x.activity == 3 && $scope.x.t3_fdate) {
				var eventTime;
				if($scope.x.t3_ftime){
				eventTime=timeparse($scope.x.t3_ftime,$scope.x.t3_fdate,1);
				}
				else{
				eventTime=timeparse('23:59:59',$scope.x.t3_fdate);
				}
				var offset = timezoneToMinutes($scope.x.t3_timezone);
				var currentDate=new Date();
				$scope.x.t3_fLocalTime = timezoneCoverter(eventTime,offset,currentDate.getTimezoneOffset());
			}

			if($scope.x.activity==13){
				$scope.x.edit_right = false;
              	if($rootScope.app_data.isAdmin && adminRights.isAllowed(22)) $scope.x.edit_right = true;
              	else if($rootScope.app_data.uid == $scope.x.poster_uid){
                	if($scope.x.approved==2){
                  	if(config && config['edit_allowed'] && config['edit_allowed']['all']) $scope.x.edit_right = true;
                	}
                	else $scope.x.edit_right = true;
              	}
			}

          	checkifcampusfeed();
		}

		function getgridClasses() {
		    if ($scope.singleVideo || $scope.x.t15_no_photos == 1) return '';

		    if (window.innerWidth <= 480) {
		    	return 'grid-square';
		    } else {
		    	if($scope.x.t15_no_photos > 3) return 'grid-rectangle-small'
		    	else return 'grid-rectangle';
		    }
		}

		function getimageDivClasses(index) {
		    var returnClasses = '';

		    if ($scope.singleVideo) return 'maximize-width ';

		    if (index == ($scope.limit_gallery - 1) && $scope.x.t15_no_photos >= ($scope.limit_gallery + 1)) {
		        returnClasses += "last-image ";
		    }

		    if (window.innerWidth > 480 && $scope.x.t15_no_photos == 4) {
		        returnClasses += 'grid-item ';
		    }

		    if($scope.x.t15_no_photos > 1) returnClasses += 'aspect-ratio-square ';

		    return returnClasses;
		}

		function getimageClasses(index) {
			var returnClasses = '';

			if ($scope.x.t15_no_photos == 1) {
				returnClasses += 'single-image';
			} else {
				returnClasses += 'maximize-width maximize-height ';
				if (index == ($scope.limit_gallery - 1) && $scope.x.t15_no_photos >= ($scope.limit_gallery + 1)) {
					returnClasses += 'image-view-more ';
				}
			}
			
			return returnClasses;
		}

		function getVideoUrl(image) {
			if(image && image.videoId){
				return $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+image.videoId);
			}
		}
		function shareModal() {			
			var dataObj = {
				title: $scope.shareTitle,
				linkTitle: $scope.linkTitle,
				link: $rootScope.COMM_APPBASE + $scope.link,
				socialsRequired:($scope.x.activity == 1)? ['fb','twitter','linkedIn','wp','tg','mail','whatsapp_tool','notification','fp','ig']:['fb','twitter','linkedIn','wp','tg','ig'],
				featureName: $scope.featureName?$scope.featureName:''
			};

			if($scope.x.approvalStatusData && $scope.x.approvalStatusData.cas_obj){
				dataObj.approval_status = $scope.x.approvalStatusData.approvalStatus;
				dataObj.approval_userType = $scope.x.approvalStatusData.userType;
				dataObj.approval_cas_id = $scope.x.approvalStatusData.cas_obj.cas_id;
			}
			socialShare.shareModal(dataObj,callback);

			function callback(shareType, event){
				var type = 1;
                if($scope.featureName && $scope.featureName == "poll")
                	type = 2;

            	if(shareType == "email"){
					$timeout(function() {cloning(type);}, 500);
            	}
				else if(shareType == "fb"){
					cloningFacebook(type, event);
				}
				else if(shareType == "notification"){
					$timeout(function() {cloningNotification(type);}, 500);
				}
				else if(shareType == "whatsapp_tool"){
					var adminWhatsappClone = $injector.get("adminWhatsappClone");
					var link = $rootScope.COMM_APPBASE + $scope.link;
					$timeout(function() {adminWhatsappClone.cloneForSharing(link);}, 500);
				}
            }
		}

		function getEditStatus(type) {
            $scope.editPost=true;
            if(type==1){

            	$scope.editPostImages=$scope.x.images;
            	$scope.editPostFiles=$scope.x.files;
            	$scope.userNewNews=$scope.x.editing_content;    
            	$scope.chipsSelected=$scope.x.editing_TaggedPeople;
            	if(angular.isArray($scope.chipsSelected) && $scope.chipsSelected.length>0) $scope.showPeopleTag = true;

            	//setting post details in object to pass
            	$scope.postdetails.postId=$scope.x.activity_id;
            	$scope.postdetails.postTitle=$scope.x.editing_content;

            	if($scope.x.activity == 1){
            		$scope.postdetails.type="news";
            	}
            	else {
	            	$scope.postdetails.eventId=$scope.x.t4_events_id;
            		$scope.postdetails.type="event";
            	}
            }else{
        		$scope.userPoll=$scope.x.editing_content;
                $scope.polldetails.pollId=$scope.x.activity_id;
	            $scope.oldPollOption=$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id];
            	$scope.polldetails.pollTitle=$scope.userPoll;

            	if($scope.x.activity == 1){
            		$scope.polldetails.type="news";
            	}
            	else {
	                $scope.polldetails.eventId=$scope.x.t4_events_id;
            		$scope.polldetails.type="event";
            	}
            }	            
            as_upgrade(100);
        }

        function canEdit() {
        	$scope.edit_allowed = false;
        	if($rootScope.app_data.isAdmin && adminRights.isAllowed(22)) $scope.edit_allowed = true;
        	else if ( $scope.x.ownership ) {
        		var key = "t" + $scope.x.activity + "_state";
        		var state = angular.isDefined($scope.x[key]) ? $scope.x[key] : null;
        		if(state==2){
        			var config = $rootScope.meta(71);
        			if(config && config['edit_allowed'] && config['edit_allowed']['all']) $scope.edit_allowed = true;
        		}
        		else $scope.edit_allowed = true;
        	}
        }

        function increaseOptions() {
            $scope.btnClicked=true;
            setTimeout(function() {
                componentHandler.upgradeAllRegistered();
            }, 10);
			var keys = Object.keys($scope.oldPollOption);
            var len = keys.length;
            $scope.count++;
            $scope.optionNumber=len;
			if($scope.count!=$scope.numOptionsArray.length){
                $scope.numOptionsArray.push({
                    content: ""
                });
            }
        }

        function fillDesc(type){
            if(type==1)
                $scope.postdetails.postTitle=$scope.userNewNews;
            else
                $scope.polldetails.pollTitle=$scope.userPoll;
        }

        function getPollTitle(){
            return $scope.Updatedcontent;
        }

        function imageRemove(index) {
            $scope.editPostImages.splice(index, 1);
        }

        function removeFile(index) {
        	$scope.editPostFiles.splice(index,1);
	    }

        function addVideo(target){
          addEditVideo.addVideo({doNotUpdate:true},function(videoId,videoName){

              if (!videoId) {  // && videoName
                 snackbar_general($filter('asPortalLang')('Adding_Video_Err',"something went wrong while adding video"),4000);
                 return;
              }

              var tempObj= {};
              tempObj={ "item": "video", "videoId": videoId,"videoName": videoName };

              $scope.editPostImages.push(tempObj);
              as_upgrade(100);

          },target.target);
        }

        function savePostEdit() {
            // var images = $scope.images.join();
            var finalPeopleTagged = [];
            var finalTagsTagged = [];
            var finalStringToSend = $scope.postdetails.postTitle;

            if (angular.isDefined($scope.chipsSelected)) {
                finalPeopleTagged = $scope.chipsSelected;
                finalStringToSend = finalStringToSend + '\n';
                for (var i = 0; i < finalPeopleTagged.length; i++) {
                    if (i == finalPeopleTagged.length - 1) {
                        finalStringToSend = finalStringToSend + '@' + finalPeopleTagged[i].name;
                    } else {
                        finalStringToSend = finalStringToSend + '@' + finalPeopleTagged[i].name + ', ';
                    }
                }
                // console.log(finalStringToSend);
            }

            finalStringToSend = stripHtmlText(finalStringToSend).replace(/\n/g,'<br />');

            if (finalStringToSend == '<br />' && isEmpty(finalPeopleTagged) && isEmpty($scope.editPostImages) && isEmpty($scope.editPostFiles)) {
              snackbar_general($filter('asPortalLang')('Req_For_Content',"Please write some content."),2000);
              return;
            }

            var data = {
                PostId : $scope.postdetails.postId,
                PostContent : finalStringToSend,
                peopleTagged: finalPeopleTagged,
                post_imgs: $scope.editPostImages,
                files_to_upload: $scope.editPostFiles
            };
            
            var url = './noticeboard_actions_c/editNewsPostAction';
            if( $scope.postdetails.type == 'event' ) {
            	url = './event_actions_c/editEventPostAction';
            	data.EventID = $scope.postdetails.eventId;
            }

            $scope.editSaving = true;
            $http.post(url,data)
            .then(function(res) {
                $scope.editSaving = false;
                if(res && res.data && res.data.success == 1) {
                    if(platform && (isAppCacheEnable || isAppCacheEnable === "true" || isAppCacheEnable === true)){
                      deleteCache("NoticeBoardCache");
                      deleteCache("ProfileCache");
                    }
                    snackbar_general($filter('asPortalLang')('Successfully_Updated',"Successfully updated"),2000);
                    $state.reload();
				}
                else {
                    snackbar_general($filter('asPortalLang')('Update_Failed_Again',"Update failed. Please try again."),4000);
                }
            });
        }

        function savePollEdit() {
            var pollOpts = [];


            pollOpts = pollOpts.concat(Object.keys($scope.oldPollOption).map(function(i) { 
                return $scope.oldPollOption[i];
            }));
            pollOpts = pollOpts.concat($scope.numOptionsArray.filter(function(v) {
                return v.content && v.content.trim && v.content.trim() != '';
            }));

            var titleStringToSend = stripHtmlText($scope.polldetails.pollTitle).replace(/\n/g, '<br />');

            var data = {
                PollId : $scope.polldetails.pollId,
                PollTitle : titleStringToSend,
                PollOption :pollOpts
            };

            var url = './noticeboard_actions_c/editNewsPollAction';
            if( $scope.polldetails.type == 'event' ) {
            	url = './event_actions_c/editEventPollAction';
            	data.EventID = $scope.polldetails.eventId;
            }

            $scope.editSaving = true;
            $http.post(url,data)
            .then(function(res) {
                $scope.editSaving = false;
                if(res && res.data && res.data.success == 1) {
                    if(platform && (isAppCacheEnable || isAppCacheEnable === "true" || isAppCacheEnable === true)){
                      deleteCache("NoticeBoardCache");
                      deleteCache("ProfileCache");
                    }
                    snackbar_general($filter('asPortalLang')('Successfully_Updated',"Successfully updated"),2000);
                    $state.reload();
                }
                else {
                    snackbar_general($filter('asPortalLang')('Update_Failed_Again',"Update failed. Please try again."),4000);
                }
            });
            
        }

        function uploadImages(files) {
          if(files.length == 0)
            return;
          var config = {
            url: './noticeboard_actions_c/getNewsImagesFromUser',
            fileKey: 'PostNews_imgs',
            extraPostData: $scope.imgName,
            reportAt: function(report) {
              if(report.current === 'done') {
                $scope.disableShare = false;
                report.done.forEach(function(v) {
                  if(v.response) {
                    imagesUploaded(v.response);
                  }
                });
              }
              else {
                $scope.imgUpload.task = report.current;
                $scope.imgUpload.current = report[report.current].processed;
              }
            }
          };
          $scope.disableShare = true;
          var report = imageBulkResizer.resize(files,config);
          $scope.imgUpload = {total: report.total};
        }


        function imagesUploaded(response) {
            if (response.data.success == 1) {
                var temp={};
                if (angular.isArray(response.data.data)) {
                    for (var i = 0; i <= response.data.data.length - 1; i++) {
                        temp.item="image";
                        // temp.imgid=i;
                        temp.src=response.data.data[i]["fullpath"];
                        $scope.editPostImages.push(temp);
                        temp={}
                    }
                } else {
                    temp.item="image";
                        // temp.imgid=0;
                        temp.src=response.data.data["fullpath"];
                        $scope.editPostImages.push(temp);
                }
            }
            $scope.imgName.myName++;
        }

        $scope.filesUploading = [];

        function uploadFiles(files) {
          	if(files.length == 0)
            	return;
            $scope.uploadingFiles = true;
            var files_to_send = [];
            var showFileSizeError = false;
            angular.forEach(files,function(v,k) {
              if(!v.size || (v.size / 1048576)<=10){
                files_to_send.push(v);
                $scope.filesUploading.push({'item':'file'});
              }
              else
                showFileSizeError = true;
            });
            if(showFileSizeError)
              snackbar_general($filter('asPortalLang')('File_Size_Err',"Files greater than [DATA:humanReadableFileSize] could not be uploaded",{'humanReadableFileSize':humanReadableFileSize(1048576*10)}),6000);
            if(!files_to_send.length){
              $scope.uploadingFiles = false;
              return;
            }
            // $scope.filesUploading = files_to_send;
          	var data = {'PostNews_files': files_to_send};
          	Upload.upload({url:'./noticeboard_actions_c/getNewsFilesFromUser',data:data})
            .then(function(res) {
              	if(res && res.data && res.data.success==1){
	                angular.forEach(res.data.data,function(value,key) {
	                	value.name = value.original;
	                	delete value.original;
	                	value.item = 'file';
	                  	$scope.editPostFiles.push(value);
	                  	$scope.filesUploading.pop();
	                });
              	}
              	else if(res && res.data && res.data.error){
		            swal(res.data.error);
		        }
              	$scope.uploadingFiles = false;
            });
        }
        

		function checkifcampusfeed(){
		    angular.forEach($scope.categories, function(value, key) {
		            $scope.categoriesId[key]=value.tagid;
		        });
		}

		//Functions
		
		function checkifcampusfeed_id(id){
			if($scope.categoriesId.indexOf(id) > -1) return true;
			return false;
		}

	    function getMorePhotos(cb)
	  	{
	  		if($scope.streamForGalleryImages==null)
	  			$scope.streamForGalleryImages = 0;
	  		$scope.streamForGalleryImages+=1
	  		$scope.lock = true;		//lock so that no more request can go until response of sent request comes
	  		$http({
	  			url: './gallaries/getGallaryPhotos',
	  			method: 'POST',
	         	data: {"gallary_id":$scope.x.t15_id,"public":1,stream:$scope.streamForGalleryImages,retrieve_universal_metadata:true},
	  			headers: {'Content-Type':'application/x-www-form-urlencoded'}
	  		}).success(function(response){
	  			 $scope.lock = false;
		         if(response.success == 1)
		    		 {
		    		 	if($scope.streamForGalleryImages==1)
		    		 		$scope.x.t15_images = response.data;

	  					if(typeof(cb) === 'function')
	            			cb(response.data);
		  			 }
		  			else if(response.success === 0)
		  			{
		  				$scope.no_more_data = true;
		  			}
		        as_upgrade(100);
	  		});
	  	}

		function redirectToGallery() {
			$state.go('inapp.gallerysupport',{id:$scope.x.t15_id});
		}

		function openImages(index,evt){
			var imgData={
	        images: $scope.x.t15_images,
	        caption: '',
	        index: index,
	        totalImgs: $scope.x.t15_no_photos,
	        loadImgs: getMorePhotos
	      }; 
	      asimageModal.imageModalbox(imgData,evt); 
		}

		function cloning(type) {
			if(type == 1)
				cloningPost();
			if(type == 2)
				cloningPoll();
		}

		function cloningPoll() {
			console.log('cloningPoll');
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
			$scope.mailblinkBlink = true;
			var mail = {};
			if(angular.isDefined($scope.x.tags))
				mail = adminMailClone.checkMailingListByTags(mail, $scope.x.tags);
			mail.subject = 'New Poll in '+$rootScope.app_data.data.short_name+' Portal';
			var content = $scope.mainContent.$$unwrapTrustedValue();
			content = mailTemplate.removeIframes(content);
			var options = pollOptions();
			options = Object.keys(options).map(function(v){return options[v]}); //turns object into array magically!!!. {a:1,b:2} --> [1,2]
			var moreOpt = '';
			var trueImg = $rootScope.app_base+'static/img/true.png';
			// var thisPostHref = $rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id;
			// auto login will be handled by backend
			var thisPostHref = '[L2L_AUTO_LOGIN]'+$rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id+'?utm_source=admin_mail&utm_medium=email&utm_campaign=post/'+$scope.x.activity_id+'[/L2L_AUTO_LOGIN]';
			if(options.length>5) {
				moreOpt = '<a href="'+thisPostHref+'" style="text-decoration: none;"><table><tbody><tr><td></td><td>View More Options</td></tr></tbody></table></a>';
			}
			var obj = {
				name: getPosterName(),
				community: $rootScope.app_data.data.short_name,
				pollContent: content,
				options: '<tr><td><img style="outline: 0;" src="{{trueImg}}" ></td><td>'+options[0].content+'</td></tr>  <tr><td><img style="outline: 0;" src="{{trueImg}}" ></td><td>'+options[1].content+'</td></tr>',
				moreOption: moreOpt,
				trueImg: trueImg,
				simpleUrl: $rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id,
				thisPostHref: thisPostHref,
				loginSrc: '[L2L_AUTO_LOGIN]'+$rootScope.COMM_APPBASE+'noticeboard'+'[/L2L_AUTO_LOGIN]',
				linkname: encodeURIComponent("Poll from "+ $rootScope.app_data.data.short_name)
			};

			if(angular.isDefined(options[2]) && options[2].content){
				obj.options=obj.options+' <tr><td><img style="outline: 0;" src="{{trueImg}}" ></td><td>'+options[2].content+'</td></tr>';
			}
			if(angular.isDefined(options[3]) && options[3].content){
				obj.options=obj.options+' <tr><td><img style="outline: 0;" src="{{trueImg}}" ></td><td>'+options[3].content+'</td></tr>';
			}
			if(angular.isDefined(options[4]) && options[4].content){
				obj.options=obj.options+' <tr><td><img style="outline: 0;" src="{{trueImg}}" ></td><td>'+options[4].content+'</td></tr>';
			}

			mailTemplate.render(['poll.html','email_sharer.html'],obj,function(res) {
				if(res.success == 1) {
					mail.content = res.template;
					adminMailClone.clone(mail);
				}
				$scope.mailblinkBlink = false;
			});
		}

		function cloningPost() {
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
			$scope.mailblinkBlink = true;
			var date = new Date();
			date.setTime(getPostedDate()*1000);
			var mail = {};
			if(angular.isDefined($scope.x.tags))
				mail = adminMailClone.checkMailingListByTags(mail, $scope.x.tags);
			mail.subject = 'News from '+$rootScope.app_data.data.short_name;
			mail.content = '';
			var content = $scope.mainContent.$$unwrapTrustedValue();
			content = mailTemplate.removeIframes(content);
			var thisPostHref = '[L2L_AUTO_LOGIN]'+$rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id+'?utm_source=admin_mail&utm_medium=email&utm_campaign=post/'+$scope.x.activity_id+'[/L2L_AUTO_LOGIN]';
			var files = getFiles();
			if(files.length>0){
				angular.forEach(files,function(val) {
					if(val.name)
						content += "<br /><a href=\""+thisPostHref+"\"><b>"+val.name+"</b></a>";
				})
			}
			console.log('content', content);
			var obj = {
				name: getPosterName(),
				date: date.toDateString(),
				content: content,
				like: getLikesCount(),
				comment: $scope.x.comments_count,
				picSrc: $scope.s3_url+"assets/images/profiles/50x50/"+posterBasicId()+".jpg",
				community: $rootScope.app_data.data.short_name,
				thisPostHref: thisPostHref,
				loginSrc: '[L2L_AUTO_LOGIN]'+$rootScope.COMM_APPBASE+'noticeboard'+'[/L2L_AUTO_LOGIN]',
				simpleUrl: $rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id,
				linkname: encodeURIComponent("News from "+ $rootScope.app_data.data.short_name)
			};
			var templates = ['news_post_wo_img.html','news_post_w1_img.html','news_post_w2_img.html','news_post_w3_img.html'];
			var templateParts=['email_sharer.html'];
			var imgs = getImages();
			var template = templates[0];
			if(imgs.length > 0) {
				if(imgs.length>2)
					template = templates[3];
				else
					template = templates[imgs.length];
				if(imgs.length==1){
					if(imgs && imgs[0] && angular.isDefined(imgs[0]['item']) && imgs[0]['item']=='video')
						imgs[0]['src']="https://img.youtube.com/vi/"+imgs[0]['videoId']+"/0.jpg"
					imageLoadErrorCheck(imgs,function(img) {
						render(img,true)
					});
				}
				if(imgs.length>1){

					if(imgs && imgs[0] && angular.isDefined(imgs[0]['item']) && imgs[0]['item']=='video')
						obj.img1="https://img.youtube.com/vi/"+imgs[0]['videoId']+"/0.jpg"
					else
						obj.img1 = imgs[0].src;

					if(imgs && imgs[1] && angular.isDefined(imgs[1]['item']) && imgs[1]['item']=='video')
						obj.img2="https://img.youtube.com/vi/"+imgs[1]['videoId']+"/0.jpg"
					else
						obj.img2 = imgs[1].src;

					obj.moreImg = imgs.length-2;
					render(obj.img1,true);
				}
				console.log("bigimg",obj);
			}
			else {
				render("",true);
			}

			function render(img1,renderSharer) {
				obj.img1 = img1;
				var inpTemp=[template];
				if (renderSharer) {
					inpTemp.push(templateParts[0]);
				}
				mailTemplate.render(inpTemp,obj,function(res) {
					if(res.success == 1) {
						mail.content = res.template;
						adminMailClone.clone(mail);
					}
					$scope.mailblinkBlink = false;
				});
			}
		}

		function cloningNotification(type){
			if(type == 1)
				cloningNotificationPost();
			if(type == 2)
				cloningNotificationPoll();
		}

		function cloningNotificationPost(){
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
			
			var notification = {};
			if(angular.isDefined($scope.x.tags))
				notification = adminNotificationClone.checkMailingListByTags(notification, $scope.x.tags);
			notification.title = "📢 News from "+$rootScope.app_data.data.short_name;

			var content = $scope.mainContent.$$unwrapTrustedValue();
			content = removeHtmlTags(content);
			if(content.length>147)
				content = content.slice(0,147) + '...';

			notification.message = content;

			var images = getImages();
			if(images){
				for (var i = 0; i < images.length; i++) {
					if (images[i].item == "image") {
						notification.imageUrl = images[i].src;
						break;
					}
				}
			}

			notification.chipData = {
				chipName: "New Post",
			 	chipState: "noticeboard",
			  	chipStateParams: {post: $scope.x.activity_id}
			};
			adminNotificationClone.clone(notification);
		}

		function cloningNotificationPoll(){
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
			
			var notification = {};
			if(angular.isDefined($scope.x.tags))
				notification = adminNotificationClone.checkMailingListByTags(notification, $scope.x.tags);
			notification.title = "🙌 What's your answer on this poll?";
			
			var content = $scope.mainContent.$$unwrapTrustedValue();
			content = removeHtmlTags(content);
			if(content.length>147)
				content = content.slice(0,147) + '...';

			notification.message = content;

			notification.chipData = {
			  	chipName: "New Poll",
			  	chipState: "noticeboard",
			  	chipStateParams: {post: $scope.x.activity_id}
			};
			adminNotificationClone.clone(notification);
		}

		function imageLoadErrorCheck(imgs,cb) {
			var tImg = new Image();
            var bigImg = imgs[0].src.replace("400x400", "1024x1024"); 
            tImg.src = bigImg;
            tImg.onload = function() {
                cb(bigImg);
            }
            tImg.onerror = function() {
                cb(imgs[0].src);
            }; 
		}

		function getPosterName() {
			var key = null;
			if($scope.x["t" + $scope.x.activity + "_unique_user_id"]) {
				key = $scope.x["t" + $scope.x.activity + "_unique_user_id"];
			}
			else if($scope.x["t" + $scope.x.activity + "_uui"]) {
				key = $scope.x["t" + $scope.x.activity + "_uui"];
			}

			try {
				return $scope.newsPeopleInvolved["uuis"][key]["first_name"] + " " +
				$scope.newsPeopleInvolved["uuis"][key]["last_name"];
			}
			catch(e) {}
		}

		function getPostedDate() {
			var key;
			if ($scope.x.activity == 1 || $scope.x.activity == 13 || $scope.x.activity == 15) {
				key = "t" + $scope.x.activity + "_time";
			} else if ($scope.x.activity == 2 || $scope.x.activity == 5) {
				key = "t" + $scope.x.activity + "_created";
			} else if ($scope.x.activity == 4) {
				key = "t" + $scope.x.activity + "_date";
			}

			var key2 = "t" + $scope.x.activity + "_state_change_time";
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus!=0 && $scope.x.approvalStatusData.approvalStatus!=3) && $scope.x[key2]) key = key2;

			return $scope.x[key];
		}

		function isContentApproved(){
			return (!$scope.x.approvalStatusData || ($scope.x.approvalStatusData.approvalStatus!=0 && $scope.x.approvalStatusData.approvalStatus!=3)) ? true : false;
		}

		function getLikesCount() {
			return $scope.x.likes_count;
		}

		function pollOptions() {
			return $scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id];
		}

		function getEventTitle() {
			return $scope.x.t3_title;
		}

		function getStartDate() {
			return $scope.x.t3_sdate;
		}

		function getEventTime() {
			return $scope.x.t3_stime;
		}

		function getEventId() {
			return $scope.x.t3_event_id;
		}

		function eventImage() {
			// console.log($scope.x.t3_event_logo);
			return $scope.x.t3_event_logo;
		}

		function getImages() {
			return $scope.x.images;
		}

		function getFiles() {
			return $scope.x.files;
		}

		function posterBasicId() {
			try{
				var key = null;
				if($scope.x["t" + $scope.x.activity + "_unique_user_id"]) {
					key = $scope.x["t" + $scope.x.activity + "_unique_user_id"];
				}
				else if($scope.x["t" + $scope.x.activity + "_uui"]) {
					key = $scope.x["t" + $scope.x.activity + "_uui"];
				}
				else if($scope.x.activity == 5 && $scope.x["t" + $scope.x.activity + "_Source"]){
					// in job content, uui is stored as a Source
					key = $scope.x["t" + $scope.x.activity + "_Source"];
				}
				else return null;
				
				return $scope.newsPeopleInvolved['uuis'][key]['user_basic_id'];
			}
			catch(e){
				return null;
			}
		}
		function posterBasic(key,key2,print) {
			if(!key || typeof(key) !== 'string') {
				key = "_unique_user_id";
			}
			if(!key2 || typeof(key2) !== 'string') {
				key2 = "uuis";
			}
			print&&console.log('return', '$scope.newsPeop..."]]:', $scope.newsPeopleInvolved[key2][$scope.x["t" + $scope.x.activity + key]],$scope.x,$scope.x["t" + $scope.x.activity + key]);
			return $scope.newsPeopleInvolved[key2][$scope.x["t" + $scope.x.activity + key]];
		}

		function eventCreatorUui() {
			return $scope.x.t3_creator;
		}

		function eventEnhancer() {
			if ($scope.x.activity_enhancer_id !== null) {
				return $scope.newsPeopleInvolved["uuis"][$scope.x.activity_enhancer_id]["first_name"] + " " +
					$scope.newsPeopleInvolved["uuis"][$scope.x.activity_enhancer_id]["last_name"];
			} else {
				return $scope.getPosterName();
			}
		}

		function eventEnhancerUid() {
			if ($scope.x.activity_enhancer_id !== null) {
				return $scope.newsPeopleInvolved["uuis"][$scope.x.activity_enhancer_id]["user_basic_id"];
			} else {
				return $scope.posterBasicId();
			}
		}

		function getDesignation() {
			if ($scope.x.t5_designation_name !== null) {
				return $scope.x.t5_designation_name;
			} else {
				return $scope.x.t5_title;
			}
		}

		function votePercentage(number) {
			if (number !== 0) {
				return {
					'width': ((number * 100) / $scope.newsmaxVote[$scope.x.activity][$scope.x.activity_id]) + '%'
				};
			}
		}

		function getParentId() {
			return $scope.x.activity_id;
		}

		function getLikeStatus() {
			return $scope.x.is_liked;
		}

		function likeCallBack() {
			if ($scope.x.is_liked === 0) {
				$scope.x.is_liked = 1;
				$scope.x.likes_count++;
			} else {
				$scope.x.is_liked = 0;
				$scope.x.likes_count--;
			}
		}

		function likeText() {
			if ($scope.x.is_liked === 0) {
				return $filter('asPortalLang')('Like',"Like");
			} else {
				return $filter('asPortalLang')('Liked',"Liked");
			}
		}

		function getmainComments() {
			// console.log(likeCommentConfig[$scope.x.activity]);
			// console.log($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id]);
			if (typeof ($scope.comments) === 'undefined') {
				return;
			} else if (typeof ($scope.comments[likeCommentConfig[$scope.x.activity]]) === 'undefined') {
				return;
			}
			if (likeCommentConfig[$scope.x.activity] == 1) {
				if (typeof ($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id]) === 'undefined') {
					return;
				} else {
					return $scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id];
				}
			} else {
				if (typeof ($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id]) === 'undefined') {
					return;
				} else {
					return $scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id];
				}
			}
		}

		function getcommentText() {
			if ($scope.x.comments_count <= 2) {
				return ($filter('asPortalLang')('Comment',"Comment"));
			} else {
				return ($scope.x.comments_count +" "+ $filter('asPortalLang')('Comments',"Comments"));
			}
		}

		function checkDates1(start_date, finish_date, booking_on, timezone, stime, ftime) {
			return datescheck(start_date, finish_date, booking_on, timezone, stime, ftime);
		}

		$scope.getEventStatus = function(start_date, finish_date, booking_on, timezone, stime, ftime) {
            return asEventService.setEventStatus(datescheck(start_date, finish_date, booking_on, timezone, stime, ftime));
        }

		function commentButtonClick() {
			try {
				$scope.focusCommentBox();
			} catch (err) {
				console.log(err);
			}
		}

		function loadAllComments() {
			if($scope.x.loadingAllComments) return;
			// if ($scope.x.comments_count > 20) {
			$scope.x.loadingAllComments = 1;
				var pid;
				if (likeCommentConfig[$scope.x.activity] != 1) {
					pid = $scope.x.activity_id;
				} else pid = $scope.x.id;

				$http({
					url: './noticeboard/getAllComments',
					method: 'POST',
					data: {
						parent_id: pid,
						parent_table: likeCommentConfig[$scope.x.activity]
					},
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).success(getAllCommentsSuccess);

				function getAllCommentsSuccess(response) {
					if (response.success == 1) {
						$scope.comments[likeCommentConfig[$scope.x.activity]][pid] = response.data;
						as_upgrade(1000);
					}
					$scope.x.loadingAllComments = 2;
				}
			// }				
		}

		function addNewComment(data) {
			if (typeof ($scope.comments[likeCommentConfig[$scope.x.activity]]) === 'undefined') {
				$scope.comments[likeCommentConfig[$scope.x.activity]] = {};
			}
			if (likeCommentConfig[$scope.x.activity] == 1) {
				if (typeof ($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id]) === 'undefined') {
					$scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id] = [];
				}
				$scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id].unshift(data.toInsert);
			} else {
				if (typeof ($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id]) === 'undefined') {
					$scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id] = [];
				}
				$scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id].unshift(data.toInsert);
			}
			$scope.x.comments_count++;
			as_upgrade(100);
		}

		function optionStyle(votes, flag) {
			if (votes !== 0) {
				return {
					'width': ((votes * 100) / $scope.x.total_votes) + '%'
				};
			} else {
				return {
					'width': '0%'
				};
			}
		}

		function voteCallBack(votedFlag, index) {
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
			$scope.x.voted_by_me = false;
			if (votedFlag === 0 || votedFlag === null) {
				$scope.x.voted_by_me =  true;
				$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id][index]['voteID'] = 1;
				$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id][index]["no_votes"]++;
			} else {
				$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id][index]['voteID'] = 0;
				$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id][index]["no_votes"]--;
			}

			angular.forEach($scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id], function (value, key) {
				if (value.voteID > 0 && key != index) {
					$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id][key]['voteID'] = 0;
					$scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id][key]["no_votes"]--;
				}
			});

			$scope.x.max_votes = 0;
			var total_votes = 0;
			angular.forEach($scope.newsPollOptions[$scope.x.activity][$scope.x.activity_id], function (value, key) {
				total_votes += parseInt(value.no_votes);
				if (parseInt(value.no_votes) > $scope.x.max_votes) {
					$scope.x.max_votes = parseInt(value.no_votes);
				}
			});
			$scope.x.total_votes = total_votes;

			setTimeout(function () {
				componentHandler.upgradeAllRegistered();
			}, 10);
		}

		function closeOptions() {
			if (angular.isDefined($scope.isChangingSettings) && $scope.isChangingSettings === true) {
				$scope.isChangingSettings = false;
			}
		}

		function toggleCommentOptions(id) {
			if (comShown == id) {
				comShown = -1;
			} else comShown = id;
		}

		function isViewingOptions(id) {
			if (id == comShown) {
				return true;
			} else return false;
		}

		function closeCommentOptions() {
			comShown = -1;
		}

		function canDelete(entity, index) {
			if (entity == "post") {
				if ($scope.x.ownership === true || ($rootScope.app_data.isAdmin === true && adminRights.isAllowed(22)) ) {
					return true;
				} else {
					return false;
				}
			} else if (entity == "comment") {
				if (likeCommentConfig[$scope.x.activity] == 1) {
					// console.log($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id][index])
					if ($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id][index]["ownership"] === true || ($rootScope.app_data.isAdmin === true && adminRights.isAllowed(22)) ) {
						return true;
					} else {
						return false;
					}
				} else {
					// console.log($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id][index]);
					if ($scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id][index]["ownership"] === true || ($rootScope.app_data.isAdmin === true && adminRights.isAllowed(22)) ) {
						return true;
					} else {
						return false;
					}
				}
			}
		}

		function deleteNewsPost() {
			$scope.x.__options.deleting = true;
			$http({
				url: './noticeboard_actions_c/removeNewsAction',
				method: 'POST',
				data: {
					newsID: $scope.x.t1_id
				},
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).success(function(response) {
				deleteNewsPostSuccess(response);
			});

			function deleteNewsPostSuccess(response) {
				$scope.x.__options.deleting = false;
				if (response.success == 1) {
                    if(platform && (isAppCacheEnable || isAppCacheEnable === "true" || isAppCacheEnable === true)){
                      deleteCache("NoticeBoardCache");
                      deleteCache("ProfileCache");
                    }
					snackbar_general($filter('asPortalLang')('Post_Delete_Msg',"Post deleted successfully!"), 2500);
					$scope.splicePost();
				}
			}
		}

		function splicePost() {
			$scope.newsData.splice($scope.$index, 1);
		}

		function trimComment(index) {
			if (likeCommentConfig[$scope.x.activity] == 1) {
				$scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.id].splice(index, 1);
			} else {
				$scope.comments[likeCommentConfig[$scope.x.activity]][$scope.x.activity_id].splice(index, 1);
			}
			$scope.x.comments_count--;
		}

		function displayVotes($event,heading) {
			var config = {
				1:1,
				2:2,
				4:3		
			};
			//poll creator or admin with content Management rights
			if((!$rootScope.app_data.isAdmin && $rootScope.app_data.uid != posterBasicId()) || 
				($rootScope.app_data.isAdmin && !adminRights.isAllowed(20)))
				return false;
			var parent_id;	
			parent_id = $scope.x.activity_id;
			searchService.modal(
                'Votes',
                {},
                {
                    title: $filter('asPortalLang')('Voters_List',"Voters List"),
                    contextSearch:{votes_display:true},
                    categories:[{fields: ["name",'votes_display'],displayName: $filter('asPortalLang')('Basic_Filters',"Basic Filters")}],
                    options: {pollOwnerUid:posterBasicId(),include_demised:true,view : {name:"votes_display",availabeFields:["name","content","time"]},keyword_filter:['name','email'],poll_id:parent_id,polltable:config[$scope.x.activity]}
                }
            );
		}

		function getLikeList($event, heading) {
			var parent_id;
			if (likeCommentConfig[$scope.x.activity] == 1) {
				parent_id = $scope.x.id;
			} else {
				parent_id = $scope.x.activity_id;
			}
			bootModal.user_list(3, {
				parent_id: parent_id,
				parentTable: likeCommentConfig[$scope.x.activity],
				heading: (angular.isDefined(heading)) ? heading : $filter('asPortalLang')('Notice_People_like_Post',"People who liked this post"),
				mobileViewMode:'alt'
			}, $event.target);
		}

		function checkDates(start_date, finish_date) {
			// console.log(start_date);
			var event_date;
			var current_date = new Date();
			if (finish_date !== null) {
				event_date = new Date(finish_date);
				if (event_date > current_date) {
					// console.log('future');
					return true;
				} else {
					// console.log('past');
					return false;
				}
			} else {
				event_date = new Date(start_date);
				if (event_date > current_date) {
					// console.log('future');
					return true;
				} else {
					// console.log('past');
					return false;
				}
			}
		}

		function scShareCard(e) {
			shareCard(e);
			return false;
			//   e = e || window.event;
			// var target = e.target || e.srcElement,
			// m, left, top;

			// while (target && target.nodeName.toLowerCase() !== 'a') {
			//   target = target.parentNode;
			// }

			// if (target && target.nodeName.toLowerCase() === 'a' && target.href) {

			//   left = Math.round((winWidth / 2) - (width / 2));
			//   top = 0;

			//   if (winHeight > height) {
			//     top = Math.round((winHeight / 2) - (height / 2));
			//   }

			//   window.open(target.href, 'intent', windowOptions + ',width=' + width +
			//     ',height=' + height + ',left=' + left + ',top=' + top);
			//   e.returnValue = false;
			//   e.preventDefault && e.preventDefault();
			// }
		}

		function cloningFacebook(type, event) {
			if(type == 1)
				cloningFacebookPost(event);
			if(type == 2)
				cloningFacebookPoll(event);
		}

		function cloningFacebookPost(event) {
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
            var facebook = {};
			
			var postLink = $rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id+'?utm_source=admin_mail&utm_medium=email&utm_campaign=post/'+$scope.x.activity_id;
			
			var content = $scope.mainContent.$$unwrapTrustedValue();
			content = removeHtmlTags(content);
            if(content.length>194) content = content.slice(0,194) + ' ......';
            var message = content+"\n\nView this news on : "+postLink;
            facebook.message = message;
            
            var obj = { message : facebook.message };
            asSocialPlatforms.openISPSharingDialog(event, obj);
		}

		function cloningFacebookPoll(event) {
			if($scope.x.approvalStatusData && ($scope.x.approvalStatusData.approvalStatus==0 || $scope.x.approvalStatusData.approvalStatus==3)) return false;
            var facebook = {};
			
			var pollLink = $rootScope.COMM_APPBASE+'post/'+$scope.x.activity_id+'?utm_source=admin_mail&utm_medium=email&utm_campaign=post/'+$scope.x.activity_id;
			
			var content = $scope.mainContent.$$unwrapTrustedValue();
			content = removeHtmlTags(content);
			if(content.length>194) content = content.slice(0,194) + ' ......';
            
            var message = "New Poll in "+$rootScope.app_data.data.short_name+" \n\n"+content+"\n\nVote on this Poll : "+pollLink;
            facebook.message = message;
            
            var obj = { message : facebook.message };
            asSocialPlatforms.openISPSharingDialog(event, obj);
		}

		function removeHtmlTags(text){
			return text ? String(text).replace(/<[^>]+>/gm, '') : '';
		}

		function deleteCache(cacheId){
			cache.deleteCache(cacheId);
			console.log(cacheId," deleted.......");
		}

		function votePreCallBack(opt) {
			if(!isContentApproved()){
				return false;
			}
			opt.indeterminate_vote=true;
			as_upgrade(100);
		}

		function pinPost() {
			$scope.x.__options.pinpost = true;
			var ischapgrp = undefined;
			var extra_note = undefined;
			if($scope.x.tag_activity==2 || $scope.x.tag_activity==3)
				ischapgrp = true;
			if($scope.x.tag_activity==2)
				extra_note = $filter('asPortalLang')('Pin_On_Grp_Note','This content belongs to a group and will be pinned within the group only.');
			if($scope.x.tag_activity==3)
				extra_note = $filter('asPortalLang')('Pin_On_Chap_Note','This content belongs to a [TERM:Chapter:lowercase] and will be pinned within the [TERM:Chapter:lowercase] only.');
			var def_duration = undefined;
			if(activity_pin_str[$scope.x.activity]=='event' || activity_pin_str[$scope.x.activity]=='event_post')
				def_duration = 'one_month';
			else if(activity_pin_str[$scope.x.activity]=='nb_post' || activity_pin_str[$scope.x.activity]=='campusfeed'){
				if(ischapgrp)
					def_duration = 'forever';
				else
					def_duration = 'one_month';
			}
			else if(activity_pin_str[$scope.x.activity]=='donation')
				def_duration = 'one_week';
			pinContent.pinPost($scope.x.activity_id,activity_pin_str[$scope.x.activity],ischapgrp,function(resp) {
				$scope.x.__options.pinpost = false;
				$state.reload();
			},function(resp) {
				$scope.x.__options.pinpost = false;
				snackbar_general($filter('asPortalLang')('Err_Something_Wrong','Something went wrong. Please try again..!!'),3000);
			},def_duration,extra_note,$scope.isCoord);
		}

		function unpinPost() {
			$scope.x.__options.unpinpost = true;
			pinContent.unpinPost(undefined,undefined,$scope.x.id,$scope.x.pin_till,function(resp) {
				$scope.x.__options.unpinpost = false;
				$state.reload();
			},function(resp) {
				$scope.x.__options.unpinpost = false;
				snackbar_general($filter('asPortalLang')('Err_Something_Wrong','Something went wrong. Please try again..!!'),3000);
			},$scope.isCoord);
		}

		function isPostPinned() {
			if($scope.x.pc_id)
				return true;
			return false;
		}

		function returnPinDate() {
			return {'Date':$filter('date')($scope.x.pin_till*1000,'dd/MM/yyyy')};
		}

		$scope.getDonationData = function(x) {
			var donated_txt = $filter('asDonation')(x.t14_terminology,'donated');
			var donation_txt = $filter('asDonation')(x.t14_terminology,'Donation');
			var donate_txt = $filter('asDonation')(x.t14_terminology,'Donate');
            var data = {
					numDonors : x.t14_no_donors,
					numTargetDonor : x.t14_donation_target_donors,
					currency : x.t14_currency,
					ammountReqd : $filter('amountFilter')(x.t14_donation_reqd_amt,x.t14_currency),
					donateTerm : $filter("asPortalLang")(donate_txt,donate_txt),
					donatedTerm : $filter("asPortalLang")(donated_txt+"_Lc",donated_txt),
					raisedAmount: $filter('amountFilter')(x.t14_raised_amount,x.t14_currency),
					donationTerm : $filter("asPortalLang")(donation_txt,donation_txt)
            };
            return data;
        }

        $scope.totalGuests = function(x) {
        	if(x.t3_total_guests!=undefined)
        		return {totalGuests: x.t3_total_guests};
        	else
        		return {totalGuests: ''};
      	}
	}
})();
